// https://fslightbox.com/javascript/documentation/basic#events
import fsLightbox from 'fslightbox';

import 'fit-text-webcomponent';
import '../../../src/docReady.js';
import Dom from '../../../src/Dom.js';
import isMobile from '../../../src/isMobile.js';
import Helper from '../../../src/Helper.js'; // easing
import './style.scss';

const moduleSelector = '.eiovisual-testo1';

/**
 * Classe esempio
 */
class Module {
    
    // _________________________________________________________________________
    
    constructor() {
        this.run();
        
        Helper.debug('Modulo testo1');
    }

    // _________________________________________________________________________
    
    /**
     * Run di questo block.
     * @returns this
     */
    run() {
        var that = this;

        docReady(() => {
            let $modules = document.querySelectorAll(moduleSelector);

            // avvia il carousel per ogni modulo trovato
            $modules.forEach(($module) => {
                new ModuleFeature($module);
            });
        });
    }
}

class ModuleFeature {
    
    constructor($module) {
        this.$module = $module;
        
        this.init_feature();
    }

    // _________________________________________________________________________

    init_feature() {
        // Tasks on images
        // setTimeout(() => { this.task1(); },100); // prima l'immagine centrale
        // setTimeout(() => { this.task2(); },500); // prima l'immagine centrale
    }
    
    // _________________________________________________________________________
    
    /**
     * FIT-TEXT
     * @returns {undefined}
     */
   
}

// export
export default new Module();